import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import {
  DatedEvidence,
  EmptyComponent,
  Evidence,
  PrimaryDetailActionbarButton,
} from '@eas/common-web';
import { TechnicalObject } from '@models';
import { EvidenceApiUrl, EvidenceBrowserUrl } from '@enums';
import { useColumns } from './technical-object-columns';
import { Fields } from './technical-object-fields';
import { useTechnicalObjectHookedSources } from './technical-object-hooked-sources';

export function TechnicalObjects() {
  const intl = useIntl();
  const columns = useColumns();
  const history = useHistory();

  const queryParams = new URLSearchParams(window.location.search);
  const workOrderId = queryParams.get('pracovnyPrikazId');
  const workOrderName = queryParams.get('pracovnyPrikaz');
  const workOrderZ105 = queryParams.get('z105');
  const location = useLocation();

  const useHookedSources = () =>
    useTechnicalObjectHookedSources(
      workOrderId ?? undefined,
      workOrderZ105 === 'true'
    );

  const evidence = DatedEvidence.useDatedEvidence<TechnicalObject>({
    identifier: 'TECHNICAL_OBJECT',
    apiProps: {
      url: EvidenceApiUrl.TECHNICAL_OBJECTS,
      hookedSources: useHookedSources,
    },
    tableProps: {
      onRowClick: (item: string | null) => {
        // custom redirect to remove query params
        if (workOrderId) {
          window.location.search = '';
          window.location.replace(
            EvidenceBrowserUrl.TECHNICAL_OBJECTS + `/${item}`
          );
        }
      },
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__TECHNICAL_OBJECT__TABLE__TITLE',
        defaultMessage: 'Technické objekty',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__TECHNICAL_OBJECT__DETAIL__TITLE',
          defaultMessage: 'Technický objekt',
        }),
        subtitle: (type) => type?.fid ?? '',
        showBtn: () => false,
        ActionBar: () => (
          <>
            {workOrderId && workOrderName && (
              <div>
                <Typography variant="body2" style={{ marginLeft: '6px' }}>
                  Zobrazujú sa vyfiltrované dáta pre pracovný príkaz{' '}
                  {workOrderName}.
                </Typography>
                <PrimaryDetailActionbarButton
                  label="Zobraziť všetko"
                  onClick={() => {
                    history.push(location.pathname);
                  }}
                />
              </div>
            )}
          </>
        ),
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: () => (
        <Fields
          workOrderId={workOrderId ?? undefined}
          workOrderName={workOrderName ?? undefined}
          isZ105={workOrderZ105 === 'true'}
        />
      ),
    },
  });

  return <Evidence {...evidence} />;
}
